export enum AccountTypes {
    Business = 1,
    Consumer = 3
}